"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _useTranslation2 = require("../../hooks/useTranslation");
var _SelectInput = require("./SelectInput");
var _icons = require("./icons");
var _Svg = require("../ui/Svg");
var _excluded = ["className", "onChange"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Flag = (0, _styledComponents.default)(_Svg.Svg)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: -5px 6px 0 0;\n  height: 14px;\n"])));
var Select = function Select(_ref) {
  var _props$component;
  var className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    i18n = _useTranslation.i18n;
  var changeLanguageValue = function changeLanguageValue(lang) {
    _jsCookie.default.set('locale', lang);
    i18n.changeLanguage(lang);
    if (onChange) onChange(lang);
  };
  var options = [{
    value: 'en',
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Flag, {
      as: _icons.flagUK
    }), " English")
  }, {
    value: 'ua',
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Flag, {
      as: _icons.flagUA
    }), " \u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430")
  }, {
    value: 'ru',
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Flag, {
      as: _icons.flagRU
    }), " \u0420\u0443\u0441\u0441\u043A\u0438\u0439")
  }];
  var value = i18n.language;
  var Component = (_props$component = props === null || props === void 0 ? void 0 : props.component) !== null && _props$component !== void 0 ? _props$component : _SelectInput.SelectInput;
  return /*#__PURE__*/_react.default.createElement(Component, {
    value: value,
    className: className,
    onChange: changeLanguageValue,
    options: options
  });
};
exports.Select = Select;